/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_MatchingInputs */

const en_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching endpoints to your use case...`)
};

const zh_hans1_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在为你的使用场景匹配接口……`)
};

const pt_br2_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando endpoints para o seu caso de uso...`)
};

const es_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando endpoints para tu caso de uso...`)
};

const fr_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en correspondance des endpoints avec votre cas d’usage...`)
};

const de_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints werden deinem Anwendungsfall zugeordnet...`)
};

const ru_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подбираем эндпоинты под вашу задачу...`)
};

const it_search_matching = /** @type {(inputs: Search_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca degli endpoint per il tuo caso d'uso...`)
};

/**
* | output |
* | --- |
* | "Matching endpoints to your use case..." |
*
* @param {Search_MatchingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_matching = /** @type {((inputs?: Search_MatchingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_MatchingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_matching(inputs)
	if (locale === "pt-BR") return pt_br2_search_matching(inputs)
	if (locale === "es") return es_search_matching(inputs)
	if (locale === "fr") return fr_search_matching(inputs)
	if (locale === "de") return de_search_matching(inputs)
	if (locale === "ru") return ru_search_matching(inputs)
	if (locale === "it") return it_search_matching(inputs)
	return en_search_matching(inputs)
});